import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { checkIfFileIsImage, getSourceFromFile, checkIfBrowserSupportsFile, } from '@libs/helpers';
import { Wrapper } from './styles';
export const FilePreview = ({ className, file }) => {
    if (!file || !checkIfBrowserSupportsFile(file))
        return null;
    const shouldRenderImg = checkIfFileIsImage(file);
    const src = getSourceFromFile(file);
    return (_jsx(Wrapper, { className: className, children: shouldRenderImg ? _jsx("img", { src: src }) : _jsx("embed", { src: src }) }));
};
const arePropsEqual = (prevProps, nextProps) => {
    return prevProps.file === nextProps.file;
};
export default memo(FilePreview, arePropsEqual);
//# sourceMappingURL=FilePreview.js.map